package com.arena_web.data.repository

import com.arena_web.data.api.UserPostApi
import com.arena_web.data.dto.CreateUserPostCommentRequest
import com.arena_web.data.dto.CreateUserPostRequest
import com.arena_web.data.dto.CreatedCommentIdDto
import com.arena_web.data.dto.ImageUploadResponse
import com.arena_web.data.dto.UserPostCommentPageDto
import com.arena_web.data.dto.UserPostDto
import com.arena_web.data.dto.UserPostPageDto
import com.arena_web.domain.repositories.UserPostRepository

class UserPostRepositoryImpl(private val userPostApi: UserPostApi) : UserPostRepository {

    override suspend fun getMyPosts(params: Map<String, String>): Result<UserPostPageDto> =
        apiCall { userPostApi.getMyPosts(params) }

    override suspend fun getPost(postId: String): Result<UserPostDto> =
        apiCall { userPostApi.getPost(postId) }

    override suspend fun createPost(request: CreateUserPostRequest): Result<UserPostDto> =
        apiCall { userPostApi.createPost(request) }

    override suspend fun deletePost(postId: String): Result<Unit> =
        apiCallUnit { userPostApi.deletePost(postId) }

    override suspend fun uploadImage(
        fileBytes: ByteArray,
        fileName: String,
        contentType: String
    ): Result<ImageUploadResponse> =
        apiCall { userPostApi.uploadImage(fileBytes, fileName, contentType) }

    override suspend fun getComments(
        postId: String,
        params: Map<String, String>
    ): Result<UserPostCommentPageDto> =
        apiCall { userPostApi.getComments(postId, params) }

    override suspend fun createComment(
        postId: String,
        request: CreateUserPostCommentRequest
    ): Result<CreatedCommentIdDto> =
        apiCall { userPostApi.createComment(postId, request) }

    override suspend fun deleteComment(commentId: String): Result<Unit> =
        apiCallUnit { userPostApi.deleteComment(commentId) }

    override suspend fun likeComment(commentId: String): Result<Map<String, Boolean>> =
        apiCall { userPostApi.likeComment(commentId) }
}
